import * as React from "react";
import { Button, Modal } from "@mantine/core";
import GameManager, { IGameManagerProps } from "./GameManager";

// import { GameManagerProps } from './GameManager';

interface IGameManagerDialogProps extends Partial<IGameManagerProps> {
  isOpen: boolean;
  hide: VoidFunction;
}

interface IGameManagerDialogState {
  error?: string;
}

class GameManagerDialog extends React.PureComponent<
  IGameManagerDialogProps,
  IGameManagerDialogState
> {
  render() {
    const inner = this.state?.error ? (
      <p>
        Error:
        {this.state.error}
      </p>
    ) : (
      <GameManager {...this.props} />
    );



    return this.props.isOpen ? (
      <Modal opened={this.props.isOpen} onClose={this.props.hide} title="Game Manager">
        {inner}
        <Button onClick={this.props.hide} color="gray" style={{ marginTop: "10px", display: "block", marginLeft: "auto" }}>
          Close
        </Button>
      </Modal>
    ) : (
      <div style={{ display: "hidden" }} />
    );
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { error: error?.toString() + error?.stack() };
  }

  componentDidCatch(error, errorInfo) {
    console.log("Caught error", error, errorInfo);
  }
}

export default GameManagerDialog;
